import AdminApi from '../../services/api'
import SonOffApi from '../../services/apiSonoff'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const SonOffApiService = new SonOffApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            username: '',
            entrances: [],
            fromDate : null,
            toDate: null,
            filter: '',
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            },
            allCustomCategories: [],
            selectedCustomCategory: null,
            useProfilePictures: false,
            showImagePreview: false,
            enableRemoteOpenDoor: CONFIG_COMPANY.ENABLE_REMOTE_OPEN_DOOR,
            imageToPreviewUserId: 0,
            imageToPreview: "",
            entranceSummaryLoading: false,
            entranceSummary: {
                totalEntrances: 0,
                bucketType: 'HOUR',
                mostPopularTime: null,
                timeStats: []
            }
        }
    },
    computed: {
        filteredEntrance() {
           if(this.selectedCustomCategory == null){
               return this.entrances;
           }
           return this.entrances.filter(e => e.customCategory === this.selectedCustomCategory)
        },
        popularEntranceTime() {
            if (!this.entranceSummary.mostPopularTime) return this.locale.t('label_no_entrance_data_for_period');
            return this.entranceSummary.mostPopularTime.timeBucket;
        },
        popularEntranceCount() {
            if (!this.entranceSummary.mostPopularTime) return this.locale.t('label_no_entrance_data_for_period');
            return Number(this.entranceSummary.mostPopularTime.entrances || 0);
        },
        timeStatsChart() {
            const stats = (this.entranceSummary.timeStats || []).slice();
            return stats.sort((a, b) => String(a.timeBucket || '').localeCompare(String(b.timeBucket || '')));
        },
        maxTimeBucketEntrances() {
            if (!this.timeStatsChart.length) return 0;
            return Math.max(...this.timeStatsChart.map(i => Number(i.entrances || 0)));
        },
        bucketLabel() {
            if ((this.entranceSummary.bucketType || '').toUpperCase() === 'HOUR') return this.locale.t('label_hour');
            return this.locale.t('label_time_bucket');
        }
    },
    methods: {
        load: load,
        loadSummary: loadSummary,
        clickSearch: clickSearch,
        tryOpenRemote: tryOpenRemote,
        openImage: openImage,
        formatDateAndTime: formatDateAndTime,
        openDoor: openDoor,
        openDoorSonOff: openDoorSonOff,
        keymonitor: keymonitor,
        getChipClassCustomCategory: getChipClassCustomCategory,
        isSelectedCustomCategory: isSelectedCustomCategory,
        clickSelectCustomCategory: clickSelectCustomCategory,
        chartWidth: chartWidth,
        listener(){
           this.load();
           this.loadSummary();
        },

    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.allCustomCategories = session.getConfig().customCategories.split(";");
        this.role = session.getRole();
        this.username = session.getUsername();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.useProfilePictures = session.getConfig().useProfilePictures == null ? true : session.getConfig().useProfilePictures;
        this.load()
        this.loadSummary()
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowImage', () => {
            _self.showImagePreview = false;
        });
        this.$trainingBus.$on('refreshEntrance', this.listener);
    },
    beforeDestroy() {
        this.$trainingBus.$off('refreshEntrance', this.listener)
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load()
                this.loadSummary()
            }
        }
    }
}

function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId;
    this.showImagePreview = true;
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
    this.loadSummary()
}



function load() {
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
    }
    AdminApiService.getEntrances(model)
        .then((response) => {
            _self.entrances = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.pagination.page = 1;
        this.load();
        this.loadSummary();
    }
}

function loadSummary() {
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
    }
    _self.entranceSummaryLoading = true;
    AdminApiService.getEntranceReportSummary(model)
        .then((response) => {
            const data = response.data || {};
            _self.entranceSummary = {
                totalEntrances: Number(data.totalEntrances || 0),
                bucketType: data.bucketType || 'HOUR',
                mostPopularTime: data.mostPopularTime || null,
                timeStats: data.timeStats || []
            };
            _self.entranceSummaryLoading = false;
        })
        .catch(error => {
            _self.entranceSummaryLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function chartWidth(value, max) {
    const v = Number(value) || 0;
    const m = Number(max) || 0;
    if (m <= 0) return '0%';
    const ratio = (v / m) * 100;
    return `${Math.max(8, Math.min(100, ratio)).toFixed(2)}%`;
}

function formatDateAndTime(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY HH:mm')
}

function openDoor(location){
    let _self = this;
    if(location == null){
        location = ''
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.openDoorEntrance(location)
        .then((response) => {
            _self.openDoorSonOff(response.data.host, response.data.deviceId, location);
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function openDoorSonOff(host, deviceId, location) {
    let _self = this;
    fetch('http://localhost:3000/open-door?baseURL=' + host +'&deviceId=' + deviceId)
        .then(response => response.text())
        .then(data => {
            console.log(data);
            swal(LocService.t("label_success"), LocService.t("label_success_open_door"), 'success')
        })
        .catch(error =>{
            _self.tryOpenRemote(location);
            console.error('Greška:', error)
        });
}

function tryOpenRemote(location){
    if(this.enableRemoteOpenDoor !== true) return;
    let _self = this;
    AdminApiService.openDoorEntranceRemote(location)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success_open_door"), 'success')
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getChipClassCustomCategory(item) {
    if (this.selectedCustomCategory === item) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedCustomCategory(item) {
    return this.selectedCustomCategory === item
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategory === item) {
        this.selectedCustomCategory = null
    } else {
        this.selectedCustomCategory = item
    }
}



// WEBPACK FOOTER //
// ./src/components/Entrance/Entrance.js